// extracted by mini-css-extract-plugin
export var container = "_dw-0";